import { registerView, View, ViewComponent } from "@frui.ts/views";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import { observer } from "mobx-react-lite";
import React from "react";
import BankTransferViewModel, { PaymentInstructionType } from "viewModels/common/payment/bankTransferViewModel";
import AlertWithInfoIcon from "views/common/alertWithInfoIcon/alertWithInfoIcon";
import { Col, Jumbotron, Row } from "react-bootstrap";
import { QRCode } from "react-qr-svg";
import SepaInstructions from "./sepaInstructions";
import classNames from "classnames";
import styles from "./bankTransfer.module.scss";
import InstructionSelect from "./instructionSelect";
import DomesticInstructions from "./domesticInstructions";

const BankTransfer: ViewComponent<BankTransferViewModel> = observer(({ vm }) => {
  const ta = (attribute: string, model?: string) => vm.localizationService.translateAttribute(model || "payment", attribute);
  const tg = (code: string) => vm.localizationService.translateGeneral(code);
  const QRCodeImage: React.FC<{ base64Svg: string }> = ({ base64Svg }) => {
    const svgXml = atob(base64Svg);
    return <div className="qr-code" dangerouslySetInnerHTML={{ __html: svgXml }} />;
  };

  return (
    <>
      {vm.chargeOrder && (
        <Row>
          <Col sm={12} md={7} className="mb-3">
            <Jumbotron className="mb-3 mb-md-0 mb-sm-3 p-4 p-md-7 w-100 multi-eshop">
              <Row>
                <Col xs={12}>
                  <h4>{tg("eshop.transfer.title")}</h4>
                </Col>
              </Row>
              <InstructionSelect vm={vm} />
              {vm.selectedPaymentType === PaymentInstructionType.Domestic ? (
                <DomesticInstructions vm={vm} />
              ) : (
                <SepaInstructions vm={vm} />
              )}
              {vm.selectedPaymentType === PaymentInstructionType.Sepa && (
                <AlertWithInfoIcon variant="info-light" className="mt-7">
                  <span>{tg("payment.info")}</span>
                </AlertWithInfoIcon>
              )}
              <AlertWithInfoIcon
                variant="warning"
                className={vm.selectedPaymentType === PaymentInstructionType.Sepa ? "mt-2" : "mt-7"}>
                <span>{vm.bankTransferInfo}</span>
              </AlertWithInfoIcon>
            </Jumbotron>
          </Col>
          <Col sm={12} md={5}>
            <div className="mb-5">
              <View vm={vm.children[0]} />
            </div>
            <View vm={vm.children[1]} />
          </Col>
        </Row>
      )}
    </>
  );
});

registerView(BankTransfer, BankTransferViewModel);
